import React from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { ArrowRight, Home } from "lucide-react";
import { useAuth } from "@/context/AuthContext";
import { useLang } from "@/context/LangContext";

// شريط عائم «رجوع / الرئيسية» على كل الصفحات خارج لوحة التحكم (السياسات، المدونة، الدليل، التقارير…) — يعيد المستخدم حيث كان
const HIDDEN = ["/", "/login", "/register"];

export const BackNav = () => {
  const { pathname } = useLocation();
  const navigate = useNavigate();
  const { user } = useAuth();
  const { t, lang } = useLang();
  const inApp = pathname.startsWith("/app") && !pathname.startsWith("/app/report/");
  if (HIDDEN.includes(pathname) || inApp) return null;
  const home = user ? "/app" : "/";
  const back = () => (window.history.length > 1 ? navigate(-1) : navigate(home));
  return (
    <div className={`fixed bottom-4 ${lang === "en" ? "left-4" : "right-4"} z-[70] flex items-center gap-2`} data-testid="back-nav">
      <button type="button" onClick={back} data-testid="back-nav-back"
        className="h-10 px-4 rounded-full bg-primary text-primary-foreground shadow-lg shadow-primary/30 text-sm font-bold flex items-center gap-1.5 hover:brightness-110 transition">
        <ArrowRight className={`w-4 h-4 ${lang === "en" ? "rotate-180" : ""}`} /> {t("رجوع", "Back")}
      </button>
      <button type="button" onClick={() => navigate(home)} data-testid="back-nav-home"
        className="h-10 w-10 rounded-full bg-card border border-border shadow-lg text-foreground flex items-center justify-center hover:border-primary transition" aria-label={t("الرئيسية", "Home")}>
        <Home className="w-4 h-4" />
      </button>
    </div>
  );
};
